import { render } from "./EditPlantDashboardPosition.vue?vue&type=template&id=242531e2"
import script from "./EditPlantDashboardPosition.vue?vue&type=script&lang=js"
export * from "./EditPlantDashboardPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__